const State = {
  idle: 'idle',
  inserting: 'inserting',
  searching: 'searching'
}

export default State
